import { ChangeDetectorRef, Component } from '@angular/core';
import { AuthService, CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { StartOrderService } from '../../custom-start-order/start-order.service';
import { ContentService } from '../../spartacus/services/content.service';
import { distinctUntilChanged } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'app-return-banner',
    templateUrl: './return-banner.component.html',
    styleUrls: ['./return-banner.component.scss'],
    standalone: false
})
export class ReturnBannerComponent {
pageLabel : string ="";
loggedin:any;
  constructor(private router:Router,private authService:AuthService,public component: CmsComponentData<CmsBannerComponent>, protected config: OccConfig, public accessService: ContentService, public cd: ChangeDetectorRef, private startOrderService: StartOrderService,private cmsService:CmsService ){
    this.cmsService.getCurrentPage().subscribe((data)=>{
      this.pageLabel = data?.pageId?data?.pageId:"";
    })
  }
  ngOnInit(){
    this.authService.isUserLoggedIn().pipe(distinctUntilChanged()).subscribe((isLoggedIn: any) => {
      this.loggedin=isLoggedIn;
      
      });
      if(!this.loggedin){
        this.router.navigate(['/homepage']);
      }
  }
}
